import client from '../httpClient';

const settingGroupStoreGetSpecifiedAreaCodeApi = (areaCode, params) => {
  return client.get(`/store-groups/settings/search-store/${areaCode}`, { params });
};

export default settingGroupStoreGetSpecifiedAreaCodeApi;
